export enum RestrictedUserRoles {
  OPERATIONS = 'Entity 74 Operations Team',
  FINANCE = 'Entity 74 Finance',
  BUSINESS = 'Entity 74 Business Team',
  ADMIN = 'Entity 74 Administrator',
}
